import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const dataModuleActions = createDataModuleActions('ACCEPT_CREDIT_LIMIT');
export const acceptCreditLimit = dataModuleActions.dataRequest;
export const acceptCreditLimitSuccess = dataModuleActions.dataSuccess;
export const acceptCreditLimitError = dataModuleActions.dataError;
export const acceptCreditLimitReset = dataModuleActions.dataReset;
